import React from "react"
import { Box } from "@chakra-ui/react"
import type { KioskScanLayout } from "../kioskLayout"
import KioskPreviewScanHeader from "./KioskPreviewScanHeader"
import KioskPreviewScanScene from "./KioskPreviewScanScene"

type Props = {
  layout: KioskScanLayout
  title: string
  logoUrl: string
  scanLabel: string
  labelFontPx: number
}

/** Scan screen: top header bar + centered scan label/camera group, absolutely positioned. */
const KioskPreviewScanScreen = ({
  layout, title, logoUrl, scanLabel, labelFontPx,
}: Props) => (
  <Box position="absolute" inset={0}>
    <KioskPreviewScanScene layout={layout} scanLabel={scanLabel} labelFontPx={labelFontPx} />
    <KioskPreviewScanHeader layout={layout.header} title={title} logoUrl={logoUrl} />
  </Box>
)

export default KioskPreviewScanScreen
